module.exports = __webpack_public_path__ + "static/homepage-dot-ornament-aae2b76aa0ecaeb5479e268e3a706d94.png";